import { useInternalAdmin } from 'hooks'
import campaignNamesForCustomer from 'main/campaignNamesAndDesc'

import styles from './ConversationBubble.module.scss'
import { ReactComponent as InfoIcon } from './info.svg'

const DeliveryStatus = ({
  hovering,
  deliveryStatus,
  isLastMessage,
  isSenderClient,
  deliveryError,
  category
}) => {
  const isInternalAdmin = useInternalAdmin()

  if (isSenderClient) {
    return null
  }

  if (hovering && deliveryStatus.match(/delivered/i) && !isLastMessage) {
    return (
      <div className={styles.deliveryStatusHover}>
        {isInternalAdmin && category && <>{campaignNamesForCustomer[category]} - </>}
        {deliveryStatus}
      </div>
    )
  }

  if (deliveryStatus.match(/delivered/i) && !isLastMessage) {
    return null
  }

  if (deliveryStatus.match(/deliveryFailed/i)) {
    return (
      <div className={styles.deliveryStatusFailed} data-tip={deliveryError}>
        <InfoIcon />
        Delivery failed
      </div>
    )
  }

  return <div className={styles.deliveryStatus}>{deliveryStatus}</div>
}

export default DeliveryStatus
